function PostHeading ({ title }) {
    return <h1 style={{fontSize:'34rem'}}>{ title }</h1>
}

export default PostHeading